import React from "react";
import { useTranslation } from "react-i18next";
import { CreditFinishedView } from "./CreditModal.styled";

const FinishedView = ({ orgaId }) => {
  const { t } = useTranslation();

  return (
    <CreditFinishedView className="fade-in">
      <img src="/images/check1.svg" className="check" alt={t("check mark")} />
      <h1>
        {t(
          "Credit has been successfully topped up. Your invoice will be created and sent shortly."
        )}{" "}
        <a href={`/prepaid-billing/${orgaId}`}>{t("All transactions.")}</a>
      </h1>
    </CreditFinishedView>
  );
};

export default FinishedView;
